var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.result=='success')?_c('SuccessPage',{attrs:{"packageInfo":_vm.packageInfo}}):_vm._e(),(_vm.result=='cancel')?_c('CancelPage'):_vm._e(),(_vm.result=='error')?_c('UnsuccessPage',{attrs:{"packageInfo":_vm.packageInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }